import CustomProductTable from "../../components/table/CustomProductTable";

export default function CustomProductControl() {
	return (
		<section className="w-full h-full px-8">
			<CustomProductTable />
		</section>
	);
}
